export default __webpack_public_path__ + "static/036-9edc91827f85f201b3ee2153fd34bd94.png";